import { CommentOptionsModalType } from "../ServiceModal.types";
import { ServiceModalInnerContainerStyles } from "../ServiceModal.styles";
import { ModalConstructor } from "../../ModalConstructor";
import { useEffect } from "react";
import CommentOptionsModalState from "./CommentOptionsModalState";
import { SELF_CLOSING_MODAL_TIMEOUT_TIME_TO_CLOSE } from "../../ServiceFunctionsModal.types";

export default function CommentOptionsModal(
    commentOptionsModalProps: CommentOptionsModalType,
) {
    function handleClosingCurrentModal() {
        commentOptionsModalProps.setOpen(false);
        commentOptionsModalProps.onClose?.();
    }

    const modalProps = CommentOptionsModalState({
        ...commentOptionsModalProps,
    });

    useEffect(() => {
        if (modalProps?.autoClosingModal) {
            const timeoutId = setTimeout(() => {
                handleClosingCurrentModal();
            }, SELF_CLOSING_MODAL_TIMEOUT_TIME_TO_CLOSE);

            return () => {
                clearTimeout(timeoutId);
            };
        }
    }, [commentOptionsModalProps.modalCurrentAction]);

    useEffect(() => {
        return () => {
            handleClosingCurrentModal();
        };
    }, []);

    return (
        <ModalConstructor
            onClose={handleClosingCurrentModal}
            open={commentOptionsModalProps.open}
            modalContent={modalProps?.modalContent && modalProps.modalContent}
            modalActions={modalProps?.modalActions && modalProps.modalActions}
            modalTitle={modalProps?.modalTitle && modalProps.modalTitle}
            isBorderRadiusVisible={true}
            isInsideClosingButtonVisible={false}
            isOutsideClosingButtonVisible={true}
            modalInnerContainerStyles={ServiceModalInnerContainerStyles}
        />
    );
}
